import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = {
    interval: Number,
    timeout: Number
  }

  connect() {
    this.startedAt = Date.now()
    this.interval = this.intervalValue || 3000
    this.timeout = this.timeoutValue || 60000
    this.timer = window.setInterval(() => this.refresh(), this.interval)
  }

  disconnect() {
    this.stop()
  }

  refresh() {
    if (Date.now() - this.startedAt >= this.timeout) {
      this.stop()
      return
    }

    Turbo.visit(window.location.href, { action: "replace" })
  }

  stop() {
    if (this.timer) {
      window.clearInterval(this.timer)
      this.timer = null
    }
  }
}
